import type { ReactNode } from "react";

export function StoriesTabStrip({
  tabs,
  active,
  onChange,
  trailing,
}: {
  tabs: { id: string; label: string }[];
  active: string;
  onChange: (id: string) => void;
  trailing?: ReactNode;
}) {
  return (
    <div className="flex flex-wrap gap-2 border-b border-black/10 pb-2 items-center">
      {tabs.map((t) => (
        <button
          key={t.id}
          type="button"
          onClick={() => onChange(t.id)}
          className={`px-3 py-1.5 text-sm ${
            active === t.id ? "bg-navy text-white" : "bg-white border border-black/10 text-navy"
          }`}
        >
          {t.label}
        </button>
      ))}
      {trailing}
    </div>
  );
}
